module.exports = __webpack_public_path__ + "media/Calvin Harris feat. Ellie Goulding - I Need Your Love (parole).d45216ff.mp3";